export function errorMessage(error:unknown,fallback:string):string{return error&&typeof error==="object"&&"message" in error&&typeof error.message==="string"?error.message:fallback;}
